enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.VirtualBrand.Registration.request',
	receive = 'MedicinalBrandsAnalytics.VirtualBrand.Registration.receive',
}

export default ActionTypes;
